/**
 * Ported VERBATIM from `apr_template/src/components/PanelCloseButton.tsx`.
 * Only import paths change. See ../compat/ for the shims.
 */
import React from 'react';

/**
 * The standard close control for the app's right-hand slide-in panels: a bold black ✕
 * on a transparent background, floating OUTSIDE the panel just left of its top-left
 * corner (the Amazon slide-in pattern).
 *
 * It is position:fixed and anchored by the panel's width (its right edge sits just left
 * of the panel's left edge), so it works even when the panel itself scrolls/clips its
 * overflow. Render it as a sibling of the panel (e.g. right after the backdrop), and
 * pass the SAME width string the panel uses, e.g. panelWidth="min(520px, 92vw)".
 */
export default function PanelCloseButton({ onClose, panelWidth, title = 'Close' }: {
  onClose: () => void; panelWidth: string; title?: string;
}) {
  return (
    <button
      onClick={onClose}
      aria-label="Close"
      title={title}
      style={{
        position: 'fixed', top: 12, right: `calc(${panelWidth} + 6px)`,
        width: 36, height: 36, border: 'none', background: 'transparent', color: '#000',
        fontSize: 30, lineHeight: 1, fontWeight: 900, cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        padding: 0, opacity: 0.85, transition: 'opacity 0.15s', zIndex: 1300,
      }}
      onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.opacity = '1'; }}
      onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.opacity = '0.85'; }}
    >
      ✕
    </button>
  );
}
